import {
  Button,
  Form,
} from '@skyline-platform/alchemy';
import Box from '@mui/material/Box';
import { ErrorMessage } from '@components/Misc';

export const ProcessErrorForm = (properties) => {
  const { message, handleSubmitNewFile } = properties ?? {};
  return (<Form
    formTitle='Process Error Form'
    footer={[
      <>
        <Button
          label='Download Excel template'
          state='default'
          type='text'
          iconLeft='fas fa-file-excel'
        />
        <Button
          label='Upload New File '
          state='filled'
          type='text'
          handleClick={handleSubmitNewFile}
        />
      </>,
    ]}
  >
    <Box className='error report'>
      <ErrorMessage message={message.message} />
    </Box>
  </Form>);
};